import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import Slides from '../slides/Slides';
import Footer from '../footer/Footer';

const Videos = ({M}) => {
   const { id } = useParams();
   const [videos,setVideos] = useState();

   const getVideos = async () => {
      await axios
      .get(`${process.env.REACT_APP_API_URL}/web/getVideos/${id}`)
      .then((payload) => {
         setVideos(payload.data);
      })
      .catch((error) => {});
   }

   useEffect(() => {
      getVideos();
   }, []);

   return (
      <>
         <Slides M={M} tipoSlides={"capacitacion"}/>
         
         <div className="section animated fadeIn">
         <div className="row">
            <div className="col s12 m12 center-align">
               <Link className="btn waves-effect waves-light light-blue accent-3" type="button" to={"/cursos"}> Volver Atras
               </Link>
            </div>
         </div>
         <div className="row">
            {videos?.map((v,index)=>{   
               return( 
                  <div key={index} className="col s12 m6">
                     <div className="card blue-grey darken-1">
                        <div className="card-content white-text">
                           <div className="embed-container" dangerouslySetInnerHTML={{__html:v.videos_iframe}}></div>
                        </div>
                     </div>
                  </div>
               )
            })}         
         </div>
      </div>
      </>
   )
}

export default Videos